import { Type } from 'class-transformer';

import { Client } from 'app/shared/models/client.model';
import { ClientReview } from 'app/shared/models/client-review.model';
/**
 * This is a model to display the Account Managers along with client reviews.
 * @author mukesh.kumar@vernuso.com (Mukesh Kumar)
 */
export class AccountManagerType {
    userId: Number;
    loginId: String;
    email: String;
    name: String;
    tenantId: Number;
    userRole: String;
    sessionId: Number;
    accessToken: String;
    clientReview: ClientReview[];
    clients: Client[];
    @Type(() => AccountManager)
    values: AccountManager[];
}

/**
 * @author mukesh.kumar@vernuso.com (Mukesh Kumar)
 */
export class AccountManager {
    userId: Number;
    loginId: String;
    email: String;
    name: String;
    tenantId: Number;
    userRole: String;
    sessionId: Number;
    accessToken: String;
    clientReview: ClientReview[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/account-manager.model.ts